$(function(){
  $("a[href^=http]:not([href*='" + location.hostname + "'])").attr("target", "_blank");
});
document.addEventListener('DOMContentLoaded', function () {
  if (window.location.pathname.includes('/cart')) {
    const btn = document.querySelector('button[name="checkout"]');
    if (!btn) return;

    const clone = btn.cloneNode(true);
    btn.parentNode.replaceChild(clone, btn);

    clone.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      console.log("🔥 checkout 強制遷移");
      window.location.href = '/checkout';
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {

  function check() {
    const btn = document.querySelector('.cowlendar-btn');
    if (!btn) return;

    let valid = true;

    // Globoの必須ラベルを起点にする
    const requiredGroups = document.querySelectorAll('.gpo-label.required');

    requiredGroups.forEach(label => {
      const wrapper = label.closest('.gpo-form__group');
      if (!wrapper) return;

      const inputs = wrapper.querySelectorAll('input, select, textarea');

      let groupValid = false;

      inputs.forEach(input => {
        if (input.type === 'checkbox' || input.type === 'radio') {
          if (input.checked) groupValid = true;
        } else {
          if (input.value && input.value.trim() !== '') groupValid = true;
        }
      });

      if (!groupValid) valid = false;
    });

    btn.disabled = !valid;
  }

  // Cowlendar対策（後読み）
  setInterval(check, 500);

});
